import { PDADataService } from "../../../services/base/PDADataService";
import { RegistrationRequest } from "../../registration/models/RegistrationRequest";


export class AuthService extends PDADataService {
  protected prefixUrl: string = `Auth`;

  // Методы token() и signOut() удалены, так как Keycloak обрабатывает авторизацию
  
  // Если нужно получать пользовательские данные с бэкенда:
  getUserInfo() {
    return this.api.get(`${this.prefixUrl}/userinfo`);
  }

  register(request: RegistrationRequest) {
    return this.api.post(`Registration/Register`, request);
  }
}
